var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"filters"},_vm._l((_vm.filters),function(filter){return _c('FilterFacet',_vm._b({key:("facet-group-" + (filter.name))},'FilterFacet',filter,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }